//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const crown = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 1, 5, 0, 0, 0, 0, 0, 0, 5, 1, 0, 
    0, 4, 2, 5, 0, 2, 2, 0, 5, 2, 4, 0, 
    0, 2, 3, 2, 2, 3, 3, 2, 2, 3, 2, 0, 
    0, 2, 2, 4, 3, 1, 1, 3, 4, 2, 2, 0, 
    0, 2, 2, 2, 3, 1, 1, 3, 2, 2, 2, 0, 
    0, 0, 2, 2, 2, 3, 3, 2, 2, 2, 0, 0, 
    0, 0, 0, 2, 2, 2, 2, 2, 2, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]